import React from "react";
import { Panel, Button } from "primereact";
import { getEnvVar } from "../config/RuntimeConfig";

interface Props {
  state;
  callback: any;
}

export class WelcomeComponent extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  private getPreviewBaseFromEnv = () => {
    const candidate =
      getEnvVar('PUBLIC_CXP_WEB_BASE_PATH') ||
      getEnvVar('PUBLIC_VERIFY_USER_URI') ||
      getEnvVar('PUBLIC_CXP_SIGN_URI');
    if (!candidate) return null;
    try {
      return new URL(candidate).origin;
    } catch {
      return null;
    }
  };

  private getPreviewUrl = () => {
    const envBase = this.getPreviewBaseFromEnv();
    if (envBase) {
      return `${envBase}/on-form/chc`;
    }
    const env = (getEnvVar('ENVIRONMENT') ?? getEnvVar('NODE_ENV') ?? "").toLowerCase();
    switch (env) {
      case "dev":
        return "https://dev.services.ontario.ca/on-form/chc";
      case "stg":
      case "stage":
      case "staging":
        return "https://stage.services.ontario.ca/on-form/chc";
      case "uat":
      case "train":
        return "https://train.test.services.ontario.ca/on-form/chc";
      case "prod":
      case "production":
        return "https://services.ontario.ca/on-form/chc";
      default:
        return "https://test.services.ontario.ca/on-form/chc";
    }
  };

  generateButtonString = () => {
    return (
      <Button
        label="Start Now"
        key="nextBtn"
        className="ontario-button ontario-button--primary"
        onClick={() => this.props.callback()}
      >
        {" "}
      </Button>
    );
  };

  render() {
    if (this.props.state.hideWelcome) return null;

    const previewUrl = this.getPreviewUrl();
    const previewBase = previewUrl.replace(/\/chc\/?$/, "");

    return (
      <div className="ontario-row ">
        <div className="ontario-columns " style={{ height: "auto" }}>
          <div className="row">
            <div className="col-sm-12 col-md-12 new-applicant-container">
              <Panel header="Welcome to Form Designer, Click Start Now to design your form. ">
                You can:{" "}
                <ul>
                  <li>
                    Design your form application by clicking the Create New Form button. You can preview your design at any time, save drafts during the creation process, and test your application in real-time. For example, if your application ID is <b>CHC</b>, it will be live simultaneously at:{" "}
                    <a href={previewUrl}>
                      {previewBase}/<b>chc</b>
                    </a>
                  </li>
                  <li>Enable authentication using either Azure Entra ID or Public Secure access.</li>
                  <li>
                    To deploy your application, you can either:
                    <ul>
                      <li>Use Docker to host it in other environments.</li>
                      <li>Keep it within the CXP Azure infrastructure.</li>
                    </ul>
                  </li>
                </ul>
              </Panel>
            </div>
          </div>
        </div>
        <p></p>
        <div style={{ marginTop: "380px", marginLeft: "12px", marginRight: "12px", display: "flex", justifyContent: "flex-end", width: "100%" }}>
          {this.generateButtonString()}
        </div>
      </div>
    );
  }
}
